import { Component, inject, OnInit, signal } from '@angular/core';
import { TitleSection } from '../../components/title-section/title-section';
import { ProgressSpinner } from 'primeng/progressspinner';
import { DataViewModule } from 'primeng/dataview';
import { IconSvg } from '../../components/icon-svg/icon-svg';
import { ChipModule } from 'primeng/chip';
import { ProviderService } from '../../services/provider.service';
import { IProviderDto } from '../../dto/dashboard';
import { Router } from '@angular/router';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-providers',
  imports: [TitleSection, IconSvg, ProgressSpinner, DataViewModule, ChipModule, PaginatorModule],
  templateUrl: './providers.html',
  styleUrl: './providers.css',
})
export class Providers implements OnInit {
  private providerService = inject(ProviderService);
  private router = inject(Router);

  isLoading = signal(false);

  providers = signal<IProviderDto[]>([]);

  ngOnInit(): void {
    this.isLoading.set(true);

    this.providerService.getProviders().subscribe({
      next: (providers) => {
        this.providers.set(providers);
      },
      error: (error) => {
        console.error("Erreur lors de la récupération des prestataires", error);
        this.isLoading.set(false);
      },
      complete: () => {
        this.isLoading.set(false);
      }
    });
  }

  selectProvider(provider: IProviderDto): void {
    this.router.navigate([`/prestataire/${provider.id}/detail`]);
  }
}
